import { IUserJson } from '@scale/shared/types/user';
import { useQuery } from 'react-query';
import {
  setLoggedInUserSelector,
  useClientStore,
} from 'react-scale/components/ExpertManagement/stores/client.store';
import apiFetch from 'react-scale/lib/api-fetch';
import { shallow } from 'zustand/shallow';

export const useFetchLoggedInUser = () => {
  const setLoggedInUser = useClientStore(setLoggedInUserSelector, shallow);
  return useQuery(
    'useFetchLoggedInUser',
    () =>
      apiFetch<IUserJson>(null, 'internal/logged_in_user', {
        method: 'GET',
      }),
    {
      staleTime: 15 * 60 * 1000,
      onSuccess: data => setLoggedInUser(data),
    },
  );
};
